import styled from "styled-components";

const ContainerTranslate = styled.div`
    display:flex;
    .ant-menu{
        width: auto !important;
    }
`

export default ContainerTranslate;